import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { listCodec, formCodec } from './codec';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPutRequest,
  createGetRequest,
  decode,
  fetchApi,
  jsonHeaders,
  setBody,
  setQuery,
} from '../..';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';
import { filterCodec } from '@/services/api/resources/filter';
import { ApprovalQuery, encodeApprovalQuery } from '@/services/api/resources/approval/query';
import { ApprovalForm } from '@/entities/approvals/model';

const baseUrl = '/v2/approvals';
const filterUrl = `${baseUrl}/filter`;
const filterStatusUrl = `${filterUrl}/status`;
const publicFilterStatusUrl = '/v2/public/approvals/filter/status';
const filterTypeUrl = `${filterUrl}/type`;
const recordUrl = (id: number) => `${baseUrl}/${id}`;
const resetUrl = (id: number) => `${recordUrl(id)}/reset`;

export const list = (query: ApprovalQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeApprovalQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const filterType = () => pipe(
  filterTypeUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const filterStatus = () => pipe(
  filterStatusUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const publicFilterStatus = () => pipe(
  publicFilterStatusUrl,
  jsonHeaders(createGetRequest),
  fetchApi,
  chain(decode(filterCodec)),
);

export const update = (data: ApprovalForm, id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(setBody(formCodec.encode(data))),
  chain(fetchApi),
);

export const remove = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const reset = (id: number) => pipe(
  id,
  resetUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const bulkDelete = (records: number[]) => resourceBulkDelete(records, baseUrl);
